<template lang="pug">
  div
    v-container.py-0(style="max-width: 600px;" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-5'")
      div.py-1.scrolling-wrapper(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
        v-btn.mr-1.ml-3(color="transparent" small icon @click="showFilter('sort')")
          v-icon(color="basic600" size="20") mdi-sort
        v-chip.s2.mx-1.text-capitalize(data-v-step='TourOrderCalendarView-1' color="info500" small :dark="Boolean(selectedFilter === 'date')" :outlined="Boolean(selectedFilter !== 'date')" :style="selectedFilter !== 'date' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('date')") date {{ dateOrder }}: {{ dateSelectionMode }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'date' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1(v-if="filters.processing || filters.ready" color="info500" small :dark="Boolean(selectedFilter === 'status')" :outlined="Boolean(selectedFilter !== 'status')" :style="selectedFilter !== 'status' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('status')") Status: {{ statusText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'status' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1(v-if="filters.shipping" color="info500" small :dark="Boolean(selectedFilter === 'shipping')" :outlined="Boolean(selectedFilter !== 'shipping')" :style="selectedFilter !== 'shipping' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('shipping')") Shipping: {{ shippingText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'shipping' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1(v-if="filters.payment" color="info500" small :dark="Boolean(selectedFilter === 'payment')" :outlined="Boolean(selectedFilter !== 'payment')" :style="selectedFilter !== 'payment' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('payment')") Payment: {{ paymentText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'payment' ? 'mdi-chevron-up' : 'mdi-chevron-down' }} 
        v-chip.s2.mx-1(v-if="filters.source" color="info500" small :dark="Boolean(selectedFilter === 'source')" :outlined="Boolean(selectedFilter !== 'source')" :style="selectedFilter !== 'source' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('source')") Source: {{ sourceText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'source' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
    v-container.pa-0(v-if="selectedFilter" style="max-width: 600px")
      .sort(v-if="selectedFilter === 'sort'")
        sort-order.px-6.pt-4.pb-0(:parentSortOrder.sync="sortOrder")

      .date(v-if="selectedFilter === 'date'")
        div.px-6.pt-4.pb-0
          div.label.basic600--text.text-uppercase {{$t('date')}}
          div.d-flex.align-center.mt-2
            div(style="margin-bottom: -6px" @click="dateOrder = 'created'")
              eva-icon(:name="dateOrder === 'created' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'created' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
            div.ml-2.p2.primary--text(@click="dateOrder = 'created'") {{$t('order_created')}}
          div.d-flex.align-center.mt-2
            div(style="margin-bottom: -6px" @click="dateOrder = 'scheduled'")
              eva-icon(:name="dateOrder === 'scheduled' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'scheduled' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
            div.ml-2.p2.primary--text(@click="dateOrder = 'scheduled'") {{$t('order_scheduled')}}
          v-divider.basic300.my-4
          div.label.basic600--text.text-uppercase {{$t('date_selection_mode')}}
          div.d-flex.align-center.mt-2
            div(style="margin-bottom: -6px" @click="dateSelectionMode = 'single'")
              eva-icon(:name="dateSelectionMode === 'single' ? 'radio-button-on' : 'radio-button-off'" :fill="dateSelectionMode === 'single' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
            div.ml-2.p2.primary--text(@click="dateSelectionMode = 'single'") {{$t('single_date')}}
          div.d-flex.align-center.mt-2
            div(style="margin-bottom: -6px" @click="dateSelectionMode = 'range'")
              eva-icon(:name="dateSelectionMode === 'range' ? 'radio-button-on' : 'radio-button-off'" :fill="dateSelectionMode === 'range' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
            div.ml-2.p2.primary--text(@click="dateSelectionMode = 'range'") {{$t('date_range')}}
          div.d-flex.align-center.mt-2
            div(style="margin-bottom: -6px" @click="dateSelectionMode = 'multiple'")
              eva-icon(:name="dateSelectionMode === 'multiple' ? 'radio-button-on' : 'radio-button-off'" :fill="dateSelectionMode === 'multiple' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
            div.ml-2.p2.primary--text(@click="dateSelectionMode = 'multiple'") {{$t('multiple_date')}}
      
      .status(v-if="selectedFilter === 'status'")
        status-order.px-6.pt-4.pb-0(:parentProcessingOrder.sync="processingOrder" :parentReadyOrder.sync="readyOrder")

      .shipping(v-if="selectedFilter === 'shipping'")
        shipping-order.px-6.pt-4.pb-0(:parentShippingOrder.sync="shippingOrder" :company="company")
      
      .payment(v-if="selectedFilter === 'payment'")
        payment-order.px-6.pt-4.pb-0(:parentPaymentOrder.sync="paymentOrder")

      .source(v-if="selectedFilter === 'source'")
        source-order.px-6.pt-4.pb-0.mb-16(:parentSourceOrder.sync="sourceOrder")

      div.d-flex.align-center.pa-4
        v-spacer
        v-btn(v-if="selectedFilter === 'sort' || selectedFilter === 'date'" color='white', text @click="resetFilter")
          .button-Aa-small.primary400--text {{$t('reset')}}
        v-btn(v-else color='white', text @click="removeFilter")
          .button-Aa-small.primary400--text {{$t('delete')}}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="updateFilter" dark)
          .button-AA-small.basic100--text {{$t('save')}}
</template>

<script>
import { mapGetters } from 'vuex'
import SortOrder from '@/components/ordermgmt/filters/SortOrder.vue'
import StatusOrder from '@/components/ordermgmt/filters/StatusOrder.vue'
import ShippingOrder from '@/components/ordermgmt/filters/ShippingOrder.vue'
import PaymentOrder from '@/components/ordermgmt/filters/PaymentOrder.vue'
import SourceOrder from '@/components/ordermgmt/filters/SourceOrder.vue'

export default {
  name: 'OrderListFiltersChip',
  components: { SortOrder, StatusOrder, ShippingOrder, PaymentOrder, SourceOrder },
  props: ['company', 'parentDateSelectionMode'],
  data: () => ({
    selectedFilter: null,
    sortOrder: 'newest',
    dateOrder: 'created',
    processingOrder: null,
    readyOrder: null,
    shippingOrder: null,
    paymentOrder: null,
    sourceOrder: null
  }),
  computed: {
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters'
    }),
    dateSelectionMode: {
      get () {
        return this.parentDateSelectionMode
      },
      set (newValue) {
        this.$emit('update:parentDateSelectionMode', newValue)
      }
    },
    statusText () {
      let status = []
      if (this.filters.processing && this.filters.processing.length > 0) {
        status.push('Processing')
      }
      if (this.filters.ready && this.filters.ready.length > 0) {
        status.push('Ready')
      }
      return status.toString()
    },
    shippingText () {
      let shipping = ''
      if (this.filters.shipping) {
        if (Object.keys(this.filters.shipping).length > 1) {
          shipping = this.sanitizeString(Object.keys(this.filters.shipping)[0]) + ' and others'
        } else {
          shipping = this.sanitizeString(Object.keys(this.filters.shipping)[0])
        }
      }
      return shipping
    },
    paymentText () {
      let payment = ''
      if (this.filters.payment && this.filters.payment.length > 0) {
        if (this.filters.payment.length > 1) {
          payment = this.filters.payment[0].name + ' and others'
        } else {
          payment = this.filters.payment[0].name
        }
      }
      return payment
    },
    sourceText () {
      let source = ''
      if (this.filters.source && this.filters.source.length > 0) {
        if (this.filters.source.length > 1) {
          source = this.sanitizeString(this.filters.source[0].name) + ' and others'
        } else {
          source = this.sanitizeString(this.filters.source[0].name)
        }
      }
      return source
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.checkFilter()
      }
    }
  },
  mounted () {
    // this.$store.commit('orders/setFilterObject', { key: 'date', value: this.dateOrder })
    // this.$store.commit('orders/setFilterObject', { key: 'sort', value: this.sortOrder })
    this.checkFilter()
  },
  methods: {
    checkFilter () {
      this.sortOrder = this.filters.sort || 'newest',
      this.dateOrder = this.filters.date || 'created',
      this.processingOrder = this.filters.processing || null,
      this.readyOrder = this.filters.ready || null,
      this.shippingOrder = this.filters.shipping || null,
      this.paymentOrder = this.filters.payment || null,
      this.sourceOrder = this.filters.source || null
    },
    showFilter (filter) {
      if (this.selectedFilter === filter) {
        this.selectedFilter = null
      } else {
        this.selectedFilter = filter
      }
    },
    sanitizeString (string) {
      let newstr = string.replace('_', ' ')
      return newstr.charAt(0).toUpperCase() + newstr.slice(1)
    },
    updateFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: this.sortOrder })
      } else if (this.selectedFilter === 'date') {
        this.$store.commit('orders/setFilterObject', { key: 'date', value: this.dateOrder })
      } else if (this.selectedFilter === 'status') {
        this.$store.commit('orders/setFilterObject', { key: 'processing', value: this.processingOrder })
        this.$store.commit('orders/setFilterObject', { key: 'ready', value: this.readyOrder })
      } else if (this.selectedFilter === 'shipping') {
        this.$store.commit('orders/setFilterObject', { key: 'shipping', value: this.shippingOrder })
      } else if (this.selectedFilter === 'payment') {
        this.$store.commit('orders/setFilterObject', { key: 'payment', value: this.paymentOrder })
      } else if (this.selectedFilter === 'source') {
        this.$store.commit('orders/setFilterObject', { key: 'source', value: this.sourceOrder })
      }
      this.selectedFilter = null
    },
    removeFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: 'newest' })
      } else if (this.selectedFilter === 'date') {
        this.$store.commit('orders/setFilterObject', { key: 'date', value: 'created' })
      } else if (this.selectedFilter === 'status') {
        this.$store.commit('orders/setFilterObject', { key: 'processing', value: null })
        this.$store.commit('orders/setFilterObject', { key: 'ready', value: null })
      } else if (this.selectedFilter === 'shipping') {
        this.$store.commit('orders/setFilterObject', { key: 'shipping', value: null })
      } else if (this.selectedFilter === 'payment') {
        this.$store.commit('orders/setFilterObject', { key: 'payment', value: null })
      } else if (this.selectedFilter === 'source') {
        this.$store.commit('orders/setFilterObject', { key: 'source', value: null })
      }
      this.selectedFilter = null
    },
    resetFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: 'newest' })
      } else if (this.selectedFilter === 'date') {
        this.$store.commit('orders/setFilterObject', { key: 'date', value: 'created' })
        this.dateSelectionMode = 'single'
      }
      this.selectedFilter = null
    }
  }
}
</script>

<style lang="scss" scoped>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>